module.exports = __webpack_public_path__ + "img/FullLogo_3254x465.2ce00502.png";